import { useContext } from '@nuxtjs/composition-api';

interface UseFeatureFlag {
  isFeatureEnabled: (key: string) => boolean;
  featureFlagEnabled: boolean;
}

const useFeatureFlag = (): UseFeatureFlag => {
  const { $config } = useContext();

  const isFeatureEnabled = (key: string): boolean => {
    const env = ($config.ENV || 'local').toLowerCase();
    const flags = $config.featureFlags || {};

    return typeof flags[key] === 'undefined' || flags[key]?.[env] === true;
  };

  return {
    isFeatureEnabled,
    featureFlagEnabled: $config.featureFlagEnabled,
  };
};

export default useFeatureFlag;
